export const FETCH = 'TICKETS/FETCH'
export const FETCH_TICKET = 'TICKETS/FETCH_TICKET'
export const CREATE = 'TICKETS/CREATE'
export const CLEAR = 'TICKETS/CLEAR'
export const CLOSE = 'TICKETS/CLOSE'
export const REOPEN = 'TICKETS/REOPEN'
export const SEND_MESSAGE = 'TICKETS/SEND_MESSAGE'
export const SET_DATA = 'TICKETS/SET_DATA'
export const SET_LOADING = 'TICKETS/SET_LOADING'
export const SET_TICKETS = 'TICKETS/SET_TICKETS'
export const DROP_LIST = 'TICKETS/DROP_LIST'
export const SET_FILTER = 'TICKETS/SET_FILTER'
export const TOGGLE_PANEL = 'TICKETS/TOGGLE_PANEL'
export const PANEL_NAVIGATE = 'TICKETS/PANEL_NAVIGATE'
